import { createSlice } from "@reduxjs/toolkit";
import { updateDocumentApi} from "../documentUploadApi";

const updateDocumentsSlice = createSlice({
  name: "updateDocument",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(updateDocumentApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDocumentApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDocumentApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default updateDocumentsSlice.reducer;
